import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FormControlErrorMessageModule } from '@portal-core/forms/components/form-control-error-message/form-control-error-message.module';
import { ProjectFilePickerInputModule } from '@portal-core/project-files/components/project-file-picker-input/project-file-picker-input.module';
import { DropdownArrowModule } from '@portal-core/ui/forms/components/dropdown-arrow/dropdown-arrow.module';
import { StylePickerInputModule } from '@portal-core/ui/style-picker/components/style-picker/style-picker-input.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { MultimediaDialogComponent } from './multimedia-dialog.component';

@NgModule({
  declarations: [
    MultimediaDialogComponent
  ],
  imports: [
    McColorModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatToolbarModule,
    MatIconModule,
    DropdownArrowModule,
    FormControlErrorMessageModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    StylePickerInputModule,
    ProjectFilePickerInputModule
  ],
  exports: [
    MultimediaDialogComponent
  ]
})
export class MultimediaDialogModule { }
